import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Arrow.scss';

const SvgArrow = ({ direction, variant, theme, className, ...props }) => {
  const svgClasses = classNames('svg', 'svg-arrow', `svg-arrow--direction-${direction}`, className);
  const pathClasses = classNames(
    'svg-arrow__path',
    `svg-arrow__path--variant-${variant}`,
    `svg-arrow__path--theme-${theme}`
  );

  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props} className={svgClasses}>
      <path className={pathClasses} fillRule="evenodd" d="M5.6 18.9l8.9-8.9-9-8.9" />
    </svg>
  );
};

SvgArrow.defaultProps = {
  direction: 'down',
  variant: 'chevron',
  theme: 'dark',
};

SvgArrow.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf(['up', 'right', 'down', 'left']),
  variant: PropTypes.oneOf(['chevron', 'triangle']),
  theme: PropTypes.oneOf(['brand', 'light', 'dark', 'disabled', 'warn', 'danger']),
};

export default SvgArrow;
